import React, { useEffect, useState } from 'react';
import { LeftArrowIcon } from 'assets/icons/AntDeisgn_icons/iconStyle';
import { BackButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import TableComponent from 'component/table_component/antTable/table';
import { AdminPageSizeWrap, AdminPageWrap, AdminTitleWrap } from 'pages/admin_page/style';
import EmailTemplateModal from 'component/modal_components/email_template';
import { Tooltip } from 'antd';
import { ReactComponent as EditIcon } from 'assets/images/SVG/icons/edit-icon.svg';
import { SpanButton } from 'component/button_components/button.style';
import { getMailTemplate, updateMailTemplate } from 'redux/slices/mailTemplateSlice';
import { useDispatch, useSelector } from 'react-redux';
import TableLoader from 'component/loader_component/tableLoader';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { InputPatternRule } from 'utils/input_pattern';

export default function EmailTemplate() {
  const [open, setOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const dispatch = useDispatch();
  const { mailTemplateData, loading } = useSelector((state) => state.mailTemplate);
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [notifyUser, setNotifyUser] = useState(false);
  const [notifyDays, setNotifyDays] = useState('');
  const [patternError, setPatternError] = useState('');
  const [apiLoading, setApiLoading] = useState(false);
  const pattern = InputPatternRule.pattern;

  const handleSubjectChange = (data) => {
    setSubject(data);
    setPatternError(pattern.test(data) ? '' : InputPatternRule.message);
  };

  const handleMessageChange = (data) => {
    setMessage(data);
  };
  const handleOnClose = () => {
    setSelectedRowData(null);
    setOpen(false);
    setNotifyDays('');
    setNotifyUser(false);
    setPatternError('');
  };

  const handleSubmit = async () => {
    const data = {
      id: selectedRowData.id,
      templateName: selectedRowData.templateName,
      subject: subject,
      message: message,
      ...((selectedRowData.id === 9 || selectedRowData.id === 10) && {
        [selectedRowData.id === 10 ? 'notifyBefore' : 'notifyAfter']: notifyDays,
        [selectedRowData.id === 10 ? 'expiryNotify' : 'expiredNotify']: notifyUser,
      }),
    };
    try {
      setApiLoading(true);
      const sweetAlert = await dispatch(updateMailTemplate(data));
      if (sweetAlert.payload && sweetAlert.payload.status === 200) {
        SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'success', buttonColor: 'green' });
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setApiLoading(false);
    }
    await dispatch(getMailTemplate());
    await handleOnClose();
  };

  useEffect(() => {
    dispatch(getMailTemplate());
  }, [dispatch]);
  const columns = [
    {
      title: 'Sl.No',
      dataIndex: 'id',
    },
    {
      title: 'Template Name',
      dataIndex: 'templateName',
    },
    {
      title: 'Subject',
      dataIndex: 'subject',
    },
    {
      title: 'Actions',
      dataIndex: 'action',
      render: (_, record) => (
        <Tooltip className='af-superadmin-template-tooltip' title='Update' color='#597081'>
          <SpanButton className='af-superadmin-template-tooltip-button' onClick={() => handleEditClick(record)}>
            <EditIcon className='af-superadmin-template-tooltip-icon' />
          </SpanButton>
        </Tooltip>
      ),
    },
  ];
  const handleEditClick = (record) => {
    setSelectedRowData(record);
    setSubject(record.subject);
    setPatternError(pattern.test(record.subject) ? '' : InputPatternRule.message);
    setMessage(record.message);
    setOpen(true);
    if (record.id === 10) {
      setNotifyDays(record.notifyBefore);
      setNotifyUser(record.expiryNotify);
    } else if (record.id === 9) {
      setNotifyDays(record.notifyAfter);
      setNotifyUser(record.expiredNotify);
    } else {
      setNotifyDays('');
      setNotifyUser(false);
    }
  };
  return (
    <AdminPageWrap className='af-superadmin-template-wrap'>
      <AdminPageSizeWrap className='af-superadmin-template-content'>
        <BackButton className='af-superadmin-template-backbutton' to='/'>
          <LeftArrowIcon className='af-superadmin-template-leftarrow' /> Back
        </BackButton>
        <AdminTitleWrap className='af-superadmin-template-title-wrap'>
          <h2 className='af-superadmin-template-title-head'>Email Templates</h2>
        </AdminTitleWrap>
        <div className='af-superadmin-template-table-wrap'>
          <TableComponent
            loading={{
              spinning: loading,
              indicator: <TableLoader />,
            }}
            columns={columns}
            data={mailTemplateData && mailTemplateData}
            key={mailTemplateData && mailTemplateData.id}
          />
        </div>
      </AdminPageSizeWrap>
      {open && (
        <EmailTemplateModal
          className='af-superadmin-template-modal'
          visible={open}
          onClose={() => {
            handleOnClose();
          }}
          selectedRowData={selectedRowData}
          id={selectedRowData.id}
          apiLoading={apiLoading}
          handleSubjectChange={handleSubjectChange}
          handleMessageChange={handleMessageChange}
          handleSubmit={handleSubmit}
          subject={subject}
          message={message}
          setSubject={setSubject}
          setMessage={setMessage}
          patternError={patternError}
          notifyDays={notifyDays}
          notifyUser={notifyUser}
          setNotifyDays={setNotifyDays}
          setNotifyUser={setNotifyUser}
        />
      )}
    </AdminPageWrap>
  );
}
